module.exports = __webpack_public_path__ + "img/huc.63f3ee85.svg";